﻿$.fn.dxCtrlIaReformule = function custom_dxCtrlIaReformule(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrliareformule dx-ctrl");
        this.createInstance(new cdxCtrlIaReformule(this, option));
    }
    return this;
}

window.cdxCtrlIaReformule = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var forTranslate = {
        "type_de_sortie": "traduire",
        "tonalite": "neutre",             // optionnel mais cohérent
        "style": "courant",               // ou "inchangé"
        "niveau": "simple",            // ou tu ne le transmets pas
        "longueur": "identique"           // important : pas "plus court" ou "développé"
    }

    if (typeof option.bddCtrl.utiCourantParaJson.reformulation == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation = {}
    if (typeof option.bddCtrl.utiCourantParaJson.reformulation.sortie == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation.sortie = typeSortieIA[0].code
    if (typeof option.bddCtrl.utiCourantParaJson.reformulation.style == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation.style = styleIA[0].code
    if (typeof option.bddCtrl.utiCourantParaJson.reformulation.tonalite == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation.tonalite = tonaliteIA[0].code
    if (typeof option.bddCtrl.utiCourantParaJson.reformulation.niveauLangue == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation.niveauLangue = niveauLangueIA[0].code
    if (typeof option.bddCtrl.utiCourantParaJson.reformulation.longueur == 'undefined') option.bddCtrl.utiCourantParaJson.reformulation.longueur = longueurIA[0].code

    if (typeof option.bddCtrl.utiCourantParaJson.translate == 'undefined') option.bddCtrl.utiCourantParaJson.translate = {}
    if (typeof option.bddCtrl.utiCourantParaJson.translate.sortie == 'undefined') option.bddCtrl.utiCourantParaJson.translate.sortie = forTranslate.type_de_sortie
    if (typeof option.bddCtrl.utiCourantParaJson.translate.style == 'undefined') option.bddCtrl.utiCourantParaJson.translate.style = forTranslate.style
    if (typeof option.bddCtrl.utiCourantParaJson.translate.tonalite == 'undefined') option.bddCtrl.utiCourantParaJson.translate.tonalite = forTranslate.tonalite
    if (typeof option.bddCtrl.utiCourantParaJson.translate.niveauLangue == 'undefined') option.bddCtrl.utiCourantParaJson.translate.niveauLangue = forTranslate.niveau
    if (typeof option.bddCtrl.utiCourantParaJson.translate.longueur == 'undefined') option.bddCtrl.utiCourantParaJson.translate.longueur = forTranslate.longueur

    //Tonalité	Amical, professionnel, neutre, enthousiaste, formel, etc.
    //Style	Soutenu, courant, familier, poétique, administratif…
    //Niveau de langue	Simple(A2 - B1), moyen(B2), avancé(C1 - C2)
    //Type de sortie	Reformulation fidèle, résumé, paraphrase avec enrichissement, etc.
    //Longueur	Même longueur, plus court, plus développé
    //Correction orthographe / grammaire	Oui / Non
    //Langue cible	Reformuler dans une autre langue(anglais, espagnol, etc.)

    var jauge = null
    var popup = null
    var $DivResult = null
    var contentElementContainer = null
    function mConstruit() {
        container.empty();

        container.css({
            "width": "100%",
            "height": "100%"
        })

        if (option.isInPopup) {
            popup = container.dxCtrlPopupBase({
                width: 700,
                maxHeight: "95%",
                height: "auto",
                shading: true,
                dragEnabled:true,
                title: "Reformuler/traduire",
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "0px 25px 25px 25px")
                    contentElementContainer = contentElement
                    mRempli()
                }
            }).dxCtrlPopupBase("instance")
            popup.show()
        } else {
            contentElementContainer = container
            mRempli()
        }
    }

    var btOk = null
    function mRempli() {
        jauge = $("<div/>").appendTo(contentElementContainer).dxCtrlJauge({}).dxCtrlJauge("instance")
        mRempliChoix()
        $DivResult = $("<div style='scroll:auto;max-height:100%;overflow-y:auto;padding:10px;border:" + theme.border + ";margin:30px;'/>").appendTo(contentElementContainer)
        $DivResult.html(option.text)

        var $Table = $("<table style=''/>").appendTo(contentElementContainer)
        var $Tr = $("<tr/>").appendTo($Table);
        $("<td style='width:100%;padding:5px;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;padding:5px;' class='tdok'/>").appendTo($Tr)
        btOk = $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Ok",
            focusStateEnabled: false,
            disabled: true,
            onClick: function (e) {
                option.onValide(html)
                if (popup) popup.hide()
            }
        }).dxCtrlButton("instance");

        var $Td = $("<td style='width:1px;padding:5px;' class='tdannuler'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Annuler",
            focusStateEnabled: false,
            onClick: function (e) {
                if (popup) popup.hide()
            }
        });

        resizeObserver.mAdd([$TableChoix, $Table], function () {
            $DivResult.css("max-height", "calc(100% - " + ($TableChoix.innerHeight() + $Table.innerHeight() + 45) + "px)")
        })()
    }

    var html = ""
    var $TableChoix = null
    function mRempliChoix() {
        $TableChoix = $("<table style='width:100%;'/>").appendTo(contentElementContainer)
        var $Tr = $("<tr/>").appendTo($TableChoix)
        var $TdTypeSortie = $("<td style='width:33%;padding:5px;'/>").appendTo($Tr)
        if (!option.traduire) {
            var newTypeSortieIA = JSON.parse(JSON.stringify(typeSortieIA))
            newTypeSortieIA.splice(newTypeSortieIA.indexOf(newTypeSortieIA.filter(function (o) { return o.code == "traduire" })[0]), 1)
            var dxSortie = $("<div/>").appendTo($TdTypeSortie).dxSelectBox({
                label: "Type de sortie",
                labelMode: 'floating',
                dataSource: newTypeSortieIA,
                displayExpr: "label",
                valueExpr: "code",
                value: option.bddCtrl.utiCourantParaJson[((option.traduire) ? "translate" : "reformulation")].sortie
            }).dxSelectBox("instance")
        }
        var $TdStyle = $("<td style='width:33%;padding:5px;'/>").appendTo($Tr)
        var dxStyle = $("<div/>").appendTo($TdStyle).dxSelectBox({
            label: "Style",
            labelMode: 'floating',
            dataSource: styleIA,
            displayExpr: "label",
            valueExpr: "code",
            value: option.bddCtrl.utiCourantParaJson[((option.traduire) ? "translate" : "reformulation")].style
        }).dxSelectBox("instance")
        var $TdTonalite = $("<td style='width:34%;padding:5px;'/>").appendTo($Tr)
        var dxTonalite = $("<div/>").appendTo($TdTonalite).dxSelectBox({
            label: "Tonalité",
            labelMode: 'floating',
            dataSource: tonaliteIA,
            displayExpr: "label",
            valueExpr: "code",
            value: option.bddCtrl.utiCourantParaJson[((option.traduire) ? "translate" : "reformulation")].tonalite
        }).dxSelectBox("instance")
        //var $Td = $("<td style='width:1px;padding:5px;' rowspan='2'/>").appendTo($Tr)
        //$("<div/>").appendTo($Td).dxCtrlButton({
        //    icon: "fas fa-refresh",
        //    hint: "Lancer la reformulation",
        //    onClick: function (e) {
        //        jauge.mShow()
        //        option.bddCtrl.mAjaxCall({
        //            command: "reformuleIA",
        //            text: option.text,
        //            sortie: dxSortie.option("value"),
        //            style: dxStyle.option("value"),
        //            tonalite: dxTonalite.option("value"),
        //            niveau_langue: dxNivLang.option("value"),
        //            longueur: dxLong.option("value"),
        //            langue: dxLangue.option("value"),
        //        }, function (data) {
        //            $DivResult.html(data.html)
        //            html = data.html
        //            $DivResult.slideDown(500)
        //            btOk.option("disabled", false)
        //            jauge.mHide()
        //        })
        //    }
        //})

        var $Tr = $("<tr/>").appendTo($TableChoix)
        var $TdNivLang = $("<td style='width:33%;padding:5px;'/>").appendTo($Tr)
        var dxNivLang = $("<div/>").appendTo($TdNivLang).dxSelectBox({
            label: "Niveau de langue",
            labelMode: 'floating',
            dataSource: niveauLangueIA,
            displayExpr: "label",
            valueExpr: "code",
            value: option.bddCtrl.utiCourantParaJson[((option.traduire) ? "translate" : "reformulation")].niveauLangue
        }).dxSelectBox("instance")
        var $TdLong = $("<td style='width:33%;padding:5px;'/>").appendTo($Tr)
        var dxLong = $("<div/>").appendTo($TdLong).dxSelectBox({
            label: "Longueur",
            labelMode: 'floating',
            dataSource: longueurIA,
            displayExpr: "label",
            valueExpr: "code",
            value: option.bddCtrl.utiCourantParaJson[((option.traduire) ? "translate" : "reformulation")].longueur
        }).dxSelectBox("instance")
        var $TdTraduire = $("<td style='width:34%;padding:5px;'/>").appendTo($Tr)
        if (option.traduire) {
            var dxLangue = $("<div style='amrgin-bottom:5px;'/>").appendTo($TdTraduire).dxSelectBox({
                label: "Langue",
                labelMode: 'floating',
                dataSource: langueIA,
                displayExpr: "label",
                valueExpr: "code",
                value: ((typeof option.langueIA == 'undefined') ? langueIA[1].code : option.langueIA)
            }).dxSelectBox("instance")
        }

        var $TdButton = $TdTraduire
        if (option.traduire) $TdButton = $TdTypeSortie
        $("<div/>").appendTo($TdButton).dxCtrlButton({
            icon: "fas fa-refresh",
            text: ((option.traduire) ? "Traduire" : "Reformuler"),
            width: "100%",
            onClick: function (e) {
                jauge.mShow()
                if (option.traduire) {
                    //option.bddCtrl.utiCourantParaJson.translate.sortie = dxSortie.option("value")
                    option.bddCtrl.utiCourantParaJson.translate.style = dxStyle.option("value")
                    option.bddCtrl.utiCourantParaJson.translate.tonalite = dxTonalite.option("value")
                    option.bddCtrl.utiCourantParaJson.translate.niveauLangue = dxNivLang.option("value")
                    option.bddCtrl.utiCourantParaJson.translate.longueur = dxLong.option("value")
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                    Me.mExeTranslate(dxLangue.option("value"))
                } else {
                    option.bddCtrl.utiCourantParaJson.reformulation.sortie = dxSortie.option("value")
                    option.bddCtrl.utiCourantParaJson.reformulation.style = dxStyle.option("value")
                    option.bddCtrl.utiCourantParaJson.reformulation.tonalite = dxTonalite.option("value")
                    option.bddCtrl.utiCourantParaJson.reformulation.niveauLangue = dxNivLang.option("value")
                    option.bddCtrl.utiCourantParaJson.reformulation.longueur = dxLong.option("value")
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                    Me.mExeReformule()
                }

                //option.bddCtrl.mAjaxCall({
                //    command: "reformuleIA",
                //    text: option.text,
                //    sortie: dxSortie.option("value"),
                //    style: dxStyle.option("value"),
                //    tonalite: dxTonalite.option("value"),
                //    niveau_langue: dxNivLang.option("value"),
                //    longueur: dxLong.option("value"),
                //    langue: "",
                //}, function (data) {
                //    $DivResult.html(data.html)
                //    html = data.html
                //    $DivResult.slideDown(500)
                //    btOk.option("disabled", false)
                //    jauge.mHide()
                //})
            }
        })
    }

    this.mExeReformule = function (funcOk) {
        option.bddCtrl.mAjaxCall({
            command: "reformuleIA",
            text: option.text,
            sortie: option.bddCtrl.utiCourantParaJson.reformulation.sortie,
            style: option.bddCtrl.utiCourantParaJson.reformulation.style,
            tonalite: option.bddCtrl.utiCourantParaJson.reformulation.tonalite,
            niveau_langue: option.bddCtrl.utiCourantParaJson.reformulation.niveauLangue,
            longueur: option.bddCtrl.utiCourantParaJson.reformulation.longueur,
            langue: "",
        }, function (data) {
            if (typeof data.date_mois == 'undefined' && typeof data.date_jour == 'undefined') {
                $DivResult.html(data.html)
                html = data.html
                $DivResult.slideDown(500)
                btOk.option("disabled", false)
                jauge.mHide()
                if (typeof funcOk != 'undefined') funcOk(data.html)
                mNotify(((option.traduire) ? "Votre texte à été traduit" : "Votre texte à été reformulé"), "success", 6000)
            } else {
                if (typeof data.date_mois != 'undefined') {
                    data.date_mois = data.date_mois.addMonths(1)
                    mNotify("Vous avez dépassé votre quota mensuel de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_mois.toFrenchDateTime(), "warning", 6000)
                } else {
                    data.date_jour = data.date_jour.addDays(1)
                    mNotify("Vous avez dépassé votre quota journalier de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_jour.toFrenchDateTime(), "warning", 6000)
                }
                jauge.mHide()
            }

        })
    }

    this.mExeTranslate = function (langage, funcOk) {
        option.bddCtrl.mAjaxCall({
            command: "reformuleIA",
            text: option.text,
            sortie: "traduire",
            style: option.bddCtrl.utiCourantParaJson.translate.style,
            tonalite: option.bddCtrl.utiCourantParaJson.translate.tonalite,
            niveau_langue: option.bddCtrl.utiCourantParaJson.translate.niveauLangue,
            longueur: option.bddCtrl.utiCourantParaJson.translate.longueur,
            langue: langage,
        }, function (data) {
            if (typeof data.date_mois == 'undefined' && typeof data.date_jour == 'undefined') {
                $DivResult.html(data.html)
                html = data.html
                $DivResult.slideDown(500)
                btOk.option("disabled", false)
                jauge.mHide()
                if (typeof funcOk != 'undefined') funcOk(data.html)
                mNotify("Votre texte à été traduit", "success", 6000)
            } else {
                if (typeof data.date_mois != 'undefined') {
                    data.date_mois = data.date_mois.addMonths(1)
                    mNotify("Vous avez dépassé votre quota mensuel de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_mois.toFrenchDateTime(), "warning", 6000)
                } else {
                    data.date_jour = data.date_jour.addDays(1)
                    mNotify("Vous avez dépassé votre quota journalier de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_jour.toFrenchDateTime(), "warning", 6000)
                }
                jauge.mHide()
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}

window.typeSortieIA = [
    { "code": "reformulation", "label": "Reformulation fidèle" },
    { "code": "resumer", "label": "Résumé du texte" },
    { "code": "enrichir", "label": "Reformulation enrichie" },
    { "code": "simplifier", "label": "Simplification du texte" },
    { "code": "developper", "label": "Développement du texte" },
    { "code": "traduire", "label": "Traduction dans une autre langue" },
    { "code": "adapter", "label": "Adaptation au public ciblé" },
    { "code": "corriger", "label": "Correction orthographique et grammaticale uniquement" }
]
window.styleIA = [
    { "code": "courant", "label": "Courant" },
    { "code": "soutenu", "label": "Soutenu" },
    { "code": "familier", "label": "Familier" },
    { "code": "écriture inclusive", "label": "Ecriture inclusive" },
    { "code": "littéraire", "label": "Littéraire" },
    { "code": "administratif", "label": "Administratif" },
    { "code": "journalistique", "label": "Journalistique" },
    { "code": "technique", "label": "Technique" },
    { "code": "scientifique", "label": "Scientifique" },
    { "code": "marketing", "label": "Marketing" },
    { "code": "commercial", "label": "Commercial" },
    { "code": "académique", "label": "Académique" },
    { "code": "créatif", "label": "Créatif" },
    { "code": "poétique", "label": "Poétique" },
    { "code": "humoristique", "label": "Humoristique" },
    { "code": "oral", "label": "Oral / Conversationnel" }
]
window.tonaliteIA = [
    { "code": "neutre", "label": "Neutre" },
    { "code": "professionnelle", "label": "Professionnelle" },
    { "code": "formelle", "label": "Formelle" },
    { "code": "informelle", "label": "Informelle" },
    { "code": "amicale", "label": "Amicale" },
    { "code": "enthousiaste", "label": "Enthousiaste" },
    { "code": "convaincante", "label": "Convaincante" },
    { "code": "positive", "label": "Positive" },
    { "code": "négative", "label": "Négative" },
    { "code": "urgente", "label": "Urgente" },
    { "code": "calme", "label": "Calme" },
    { "code": "assertive", "label": "Assertive" },
    { "code": "pédagogique", "label": "Pédagogique" },
    { "code": "créative", "label": "Créative" },
    { "code": "humoristique", "label": "Humoristique" },
    { "code": "ironique", "label": "Ironique" },
    { "code": "émotive", "label": "Émotive" }
]
window.niveauLangueIA = [
    { "code": "simple", "label": "Simple (niveau A2-B1)" },
    { "code": "moyen", "label": "Intermédiaire (niveau B2)" },
    { "code": "avance", "label": "Avancé (niveau C1-C2)" }
]
window.longueurIA = [
    { "code": "identique", "label": "Longueur identique" },
    { "code": "plus_court", "label": "Plus court" },
    { "code": "plus_long", "label": "Plus long" },
    { "code": "resume", "label": "Résumé très bref" },
    { "code": "developpe", "label": "Développement détaillé" }
]
window.langueIA = [
    { "code": "fr", "label": "Français" },
    { "code": "en", "label": "Anglais" },
    { "code": "es", "label": "Espagnol" },
    { "code": "de", "label": "Allemand" },
    { "code": "it", "label": "Italien" },
    { "code": "pt", "label": "Portugais" },
    { "code": "nl", "label": "Néerlandais" },
    { "code": "pl", "label": "Polonais" },
    { "code": "sv", "label": "Suédois" },
    { "code": "da", "label": "Danois" },
    { "code": "no", "label": "Norvégien" },
    { "code": "fi", "label": "Finnois" },
    { "code": "ro", "label": "Roumain" },
    { "code": "hu", "label": "Hongrois" },
    { "code": "cs", "label": "Tchèque" },
    { "code": "sk", "label": "Slovaque" },
    { "code": "bg", "label": "Bulgare" },
    { "code": "ru", "label": "Russe" },
    { "code": "tr", "label": "Turc" },
    { "code": "el", "label": "Grec" },
    { "code": "ar", "label": "Arabe" },
    { "code": "he", "label": "Hébreu" },
    { "code": "zh", "label": "Chinois (simplifié)" },
    { "code": "ja", "label": "Japonais" },
    { "code": "ko", "label": "Coréen" },
    { "code": "hi", "label": "Hindi" },
    { "code": "th", "label": "Thaï" },
    { "code": "vi", "label": "Vietnamien" }
]